import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { Form, FieldTextInput } from '../../components';

import css from './CustomerSignupForms.css';

const customerLookingForOptions = [
  { key: 'brand_design', translationId: 'CustomerSignupForms.talentBrandDesign' },
  { key: 'copywriting_content', translationId: 'CustomerSignupForms.talentCopywritingContent' },
  { key: 'social_media', translationId: 'CustomerSignupForms.talentSocialMedia' },
  {
    key: 'advertising_analytics',
    translationId: 'CustomerSignupForms.talentAdvertisingAnalytics',
  },
  { key: 'pr_communications', translationId: 'CustomerSignupForms.talentPRCommunications' },
  { key: 'websites_ecommerce', translationId: 'CustomerSignupForms.talentWebsitesEcommerce' },
  { key: 'ui_ux_design', translationId: 'CustomerSignupForms.talentUIUXDesign' },
  { key: 'ai_automation', translationId: 'CustomerSignupForms.talentAIAutomation' },
  { key: 'photo_video', translationId: 'CustomerSignupForms.talentPhotoVideo' },
  { key: 'other', translationId: 'CustomerSignupForms.talentOther' },
];

const KEY_CODE_ENTER = 13;

const CustomerSignupStep3Form = props => {
  const { onSubmit, onPrev, initialValues, intl, submitInProgress, onOpenTermsOfService } = props;

  const [selectedTalent, setSelectedTalent] = useState(initialValues.lookingFor || []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  useEffect(() => {
    setSelectedTalent(initialValues.lookingFor || []);
  }, [initialValues.lookingFor]);

  // lookingForText
  const lookingForTextLabel = intl.formatMessage({ id: 'CustomerSignupForms.lookingForTextLabel' });
  const lookingForTextPlaceholder = intl.formatMessage({
    id: 'CustomerSignupForms.lookingForTextPlaceholder',
  });

  const toggleTalent = key => {
    setSelectedTalent(prev => (prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]));
  };

  const handleTermsKeyUp = e => {
    if (e.keyCode === KEY_CODE_ENTER && onOpenTermsOfService) {
      onOpenTermsOfService();
    }
  };

  const termsLink = onOpenTermsOfService ? (
    <span
      className={css.termsLink}
      onClick={onOpenTermsOfService}
      role="button"
      tabIndex="0"
      onKeyUp={handleTermsKeyUp}
    >
      <FormattedMessage id="SignupForm.termsAndConditionsLinkText" />
    </span>
  ) : null;

  return (
    <FinalForm
      initialValues={{
        lookingForText: initialValues.lookingForText || '',
      }}
      onSubmit={values => {
        onSubmit({
          lookingFor: selectedTalent,
          lookingForText: values.lookingForText || '',
        });
      }}
      render={fieldRenderProps => {
        const { handleSubmit, values } = fieldRenderProps;

        const tosAccepted = values.tosAccepted;
        const submitDisabled = submitInProgress || !tosAccepted || selectedTalent.length === 0;

        const handleBack = () => {
          onPrev({
            lookingFor: selectedTalent,
            lookingForText: values.lookingForText || '',
          });
        };

        return (
          <Form className={css.root} onSubmit={handleSubmit}>
            <div className={css.formFields}>
              {/* What kind of talent are you interested in? - checkbox grid */}
              <div className={css.checkboxGrid}>
                {customerLookingForOptions.map(opt => {
                  const isSelected = selectedTalent.includes(opt.key);
                  return (
                    <label
                      key={opt.key}
                      className={css.checkboxItem}
                      onClick={() => toggleTalent(opt.key)}
                    >
                      <span className={isSelected ? css.checkboxChecked : css.checkboxUnchecked} />
                      <span className={css.checkboxLabel}>
                        {intl.formatMessage({ id: opt.translationId })}
                      </span>
                    </label>
                  );
                })}
              </div>

              {/* Anything else to add? */}
              <FieldTextInput
                rootClassName={css.field}
                inputRootClass={css.textAreaTall}
                type="textarea"
                id="lookingForText"
                name="lookingForText"
                label={lookingForTextLabel}
                placeholder={lookingForTextPlaceholder}
                showSpacer={false}
              />
            </div>

            {/* TOS + Submit */}
            <div className={css.bottomWrapper}>
              <Field name="tosAccepted" type="checkbox">
                {({ input }) => (
                  <label className={css.termsRow}>
                    <input className={css.termsCheckbox} type="checkbox" {...input} />
                    <span className={css.termsText}>
                      <FormattedMessage
                        id="SignupForm.termsAndConditionsAcceptText"
                        values={{ termsLink }}
                      />
                    </span>
                  </label>
                )}
              </Field>
              <div className={css.submitContainer}>
                <button type="button" className={css.backButton} onClick={handleBack}>
                  <FormattedMessage id="CustomerSignupForms.previousButton" />
                </button>
                <button type="submit" className={css.submitButtonGreen} disabled={submitDisabled}>
                  {submitInProgress ? (
                    '...'
                  ) : (
                    <FormattedMessage id="CustomerSignupForms.signUpButton" />
                  )}
                </button>
              </div>
            </div>
          </Form>
        );
      }}
    />
  );
};

export default compose(injectIntl)(CustomerSignupStep3Form);
